import { format, formatISO as dfFormatISO, isValid, parse, parseISO } from 'date-fns';
import { ru } from 'date-fns/locale';

import { i18n } from '../modules/lang/LangAdapter';

export default class DateHelper {
  static getDateFnsLocale = () => {
    switch (i18n.language) {
      // case LangTypeEnum.EN:
      //   return enUS;

      default:
        return ru;
    }
  };

  static newDateWithParseIOS = (date: string) => {
    return new Date(parseISO(date));
  };

  static formatWithParseISO = (date: string | null | undefined, formatString = 'dd.MM.yyyy') => {
    if (typeof date !== 'string' || !isValid(DateHelper.newDateWithParseIOS(date))) {
      console.log('Invalid date');
      return;
    }

    return format(parseISO(date), formatString, {
      locale: DateHelper.getDateFnsLocale(),
    });
  };

  static formatWithParse = (date: string | null | undefined, outputFormat: string, parseFormat = 'dd.MM.yyyy') => {
    if (typeof date !== 'string') {
      console.log('Invalid date');
      return;
    }

    return format(parse(date, parseFormat, new Date()), outputFormat, {
      locale: DateHelper.getDateFnsLocale(),
    });
  };

  static formatFromDate = (date: Date, customFormat = 'dd.MM.yyyy') => {
    return format(date, customFormat, {
      locale: DateHelper.getDateFnsLocale(),
    });
  };

  static formatISO: typeof dfFormatISO = (...arg) => {
    return dfFormatISO(...arg);
  };

  static isValid = (date: Date) => {
    return isValid(date);
  };
}
